/**
 * Formatters for the inbox, which works with ISO strings straight from the API
 * and with per-item currencies — unlike utils/formatters.ts, which takes Date
 * objects and assumes EUR.
 */

export function formatAmount(value: number | null, currency: string | null): string {
  if (value == null) return '–'
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency || 'EUR',
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatDate(value: string | null): string {
  if (!value) return '–'
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString('de-DE')
}

export function formatDateTime(value: string | null): string {
  if (!value) return '–'
  const d = new Date(value)
  return Number.isNaN(d.getTime())
    ? value
    : d.toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
}

export function formatTime(value: Date | null): string {
  if (!value) return '–'
  return value.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
}
